import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';


function InputDialog(props) {
  
    const [newDisplayName, setNewDisplayName] = useState();


    const handleOK = () => {

        if (newDisplayName && newDisplayName!=="" && newDisplayName!==props.defaultFieldValue)
            props.setDisplayName(props.defaultFieldValue, newDisplayName);

        handleClose();
    };


    const handleCancel = () => {
      
      props.toggleDataField(props.defaultFieldValue); //removes data field and star

      handleClose();
  };

    const handleClose = () => {

        props.setDialogOpen(false);
    };

    


  

  return (
    <div>      
    
      <Dialog open={true} onClose={handleClose}  aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">visningsnavn</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Vennligst angi visningsnavn for datafeltet.
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="name"
            label="Visningsnavn"
            type="text"
            defaultValue ={props.defaultFieldValue}
            fullWidth
            onChange={e => setNewDisplayName(e.target.value)}
          />
        </DialogContent>
        <DialogActions>          
          <Button onClick={handleCancel} color="primary">
            Avbryt
          </Button>
          <Button onClick={handleOK} color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default InputDialog;